/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum AuditLogEventAction {
    abandon = 'abandon',
    activate = 'activate',
    add_balance = 'add_balance',
    add_role = 'add_role',
    add_tenant = 'add_tenant',
    add_user = 'add_user',
    apply = 'apply',
    approve = 'approve',
    archive = 'archive',
    cancel = 'cancel',
    clone = 'clone',
    configure = 'configure',
    create = 'create',
    deactivate = 'deactivate',
    definition = 'definition',
    delete = 'delete',
    disable = 'disable',
    dismiss = 'dismiss',
    download = 'download',
    enable = 'enable',
    execute = 'execute',
    export = 'export',
    import = 'import',
    inventory_action = 'inventory_action',
    login = 'login',
    open = 'open',
    postpone = 'postpone',
    publish = 'publish',
    reactivate = 'reactivate',
    reject = 'reject',
    remediate = 'remediate',
    remove_role = 'remove_role',
    remove_tenant = 'remove_tenant',
    remove_user = 'remove_user',
    retry = 'retry',
    reorder = 'reorder',
    request_review = 'request_review',
    rerun = 'rerun',
    resolve = 'resolve',
    revoke = 'revoke',
    save_commit = 'save_commit',
    schedule = 'schedule',
    set_defaults = 'set_defaults',
    share = 'share',
    share_report = 'share_report',
    start_scan = 'start_scan',
    submit = 'submit',
    suspend = 'suspend',
    terminate = 'terminate',
    trigger = 'trigger',
    update = 'update',
    version = 'version'
}
